module.exports = __webpack_public_path__ + "static/media/R-PANELv6.5-RC1/contactIcon.ca02b8b4.svg";